import { render, staticRenderFns } from "./TagsTabSidebar.vue?vue&type=template&id=af74e900&scoped=true"
import script from "./TagsTabSidebar.vue?vue&type=script&lang=js"
export * from "./TagsTabSidebar.vue?vue&type=script&lang=js"
import style0 from "./TagsTabSidebar.vue?vue&type=style&index=0&id=af74e900&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af74e900",
  null
  
)

export default component.exports